/** Id suffixes that split a recurring entity into one node per column (DAG). */
export const THREE_TIER_NODE_SUFFIXES = {
  inflow: '__inflow',
  outflow: '__outflow',
  cycleInflow: '__cycle_inflow',
  cycleOutflow: '__cycle_outflow',
} as const;
